// ============================================================
// VCE — Análisis de contenido (función pura)
// ============================================================
// Convierte items tipados + descriptores → ContentProfile NEUTRO.
// El motor no interpreta el significado: solo mide y clasifica. (P1)
// ============================================================
import type { ContentProfile, InfoWeight, PresentationContext, VisualItem } from '../types';

export interface InfoDescriptors {
  /** Longitud real de los textos (caracteres) — la mide el consumidor */
  infoLength?: number;
  hasDescription?: boolean;
  /** Token NEUTRO de estado (p. ej. 'blocked') — significado = tenant */
  state?: string;
  actionCount?: number;
}

const HEAVY_LENGTH = 160;
const NORMAL_LENGTH = 40;

function classifyInfoWeight(length: number): InfoWeight {
  if (length > HEAVY_LENGTH) return 'heavy';
  if (length > NORMAL_LENGTH) return 'normal';
  return 'minimal';
}

export function buildContentProfile(
  items: VisualItem[],
  info: InfoDescriptors = {},
  context: PresentationContext = 'card',
): ContentProfile {
  const mediaTypes = Array.from(new Set(items.map((i) => i.type)));
  return {
    mediaCount: items.length,
    mediaTypes,
    hasVideo: mediaTypes.includes('video'),
    hasPoster: items.some((i) => !!i.poster),
    infoWeight: classifyInfoWeight(info.infoLength ?? 0),
    hasDescription: !!info.hasDescription,
    state: info.state,
    actionCount: info.actionCount ?? 0,
    context,
  };
}
